import {
  select, call, put, takeEvery,
} from 'redux-saga/effects';
import api from 'linkia-api';

import {
  LIST,
  GET,
  UPDATE,
  REMOVE,
  CREATE,
} from './action-types';
import {
  list,
  reset,
  requestFailed,
  listSucceeded,
  getSucceeded,
  updateSucceeded,
  removeSucceeded,
  createSucceeded,
} from './actions';

import { tokenSelector } from '../login/selectors';

function* listCourseModalities() {
  const token = yield select(tokenSelector);
  try {
    const data = yield call(api.courseModality.getAll, { token });
    yield put(listSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* getCourseModality(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const data = yield call(api.courseModality.get, { token, id });
    yield put(getSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* updateCourseModality(action) {
  const token = yield select(tokenSelector);
  const { id, data } = action;
  try {
    const success = yield call(api.courseModality.update, { token, id, data });
    yield put(updateSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* removeCourseModality(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const success = yield call(api.courseModality.delete, { token, id });
    yield put(removeSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* createCourseModality(action) {
  const token = yield select(tokenSelector);
  const { data } = action;
  try {
    const success = yield call(api.courseModality.create, { token, data });
    yield put(createSucceeded(success));
    yield put(reset());
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

export default [
  takeEvery(LIST, listCourseModalities),
  takeEvery(GET, getCourseModality),
  takeEvery(UPDATE, updateCourseModality),
  takeEvery(REMOVE, removeCourseModality),
  takeEvery(CREATE, createCourseModality),
];
